import { DEFAULT_MAX_UNIT_PRICE } from "../../../models/posm/posm.constant"
import ViewBase from "../../../views/view-base.view"

function DecimalNumbeInputComponent() {
  ViewBase.call(this);
  const constructNumber = (wholeNumber, decimal) => {
    return wholeNumber + '.' + decimal
  }
  const isDecimalInvalid = (required, wholeNumber, decimal) => {
    if (required && (wholeNumber == '' || Number(constructNumber(wholeNumber, decimal)) == 0)) {
      return true
    }
    return false
  }
  return {
    view: ({ attrs: { disabled = false, required = false, value, onChange } }) => {
      let [wholeNumber, decimal = '00'] = `${value}`.split('.')
      return [
        m(`.d-flex.gap-2${isDecimalInvalid(required, wholeNumber, decimal) ? '.is-invalid-custom' : ''}`,
          m(`input#qty.form-control.form-control-bg.easepick-input${isDecimalInvalid(required, wholeNumber, decimal) ? '.is-invalid-custom' : ''}`,
            {
              disabled,
              required,
              value: wholeNumber,
              oninput: (e) => {
                const input = e.target;
                input.value = input.value.match(/[1-9]\d{0,11}|0{1}|/g)[0]
                if (parseInt(input.value, 10) > DEFAULT_MAX_UNIT_PRICE) {
                  if (input.value.length > 12)
                    input.value = input.value.slice(0, 12)
                }
                onChange(constructNumber(input.value, decimal))
              }
            }
          ),

          m('span.align-content-end', '.'),
          m(`input.form-control.form-control-bg.easepick-input${isDecimalInvalid(required, wholeNumber, decimal) ? '.is-invalid-custom' : ''}`,
            {
              disabled,
              required: required && Number(wholeNumber) == 0,
              value: decimal,
              style: 'flex-shrink: 2',
              maxlength: 2,
              oninput: (e) => {
                let value = e.target.value.match(/\d{0,2}|/)[0]
                onChange(constructNumber(wholeNumber, value))
              }
            }
          )
        ),
        m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
      ]
    }
  }
}
export default DecimalNumbeInputComponent